import clsx from "clsx"

import { faIcon } from "@utils/faIcon"

import { Icon } from "@atoms"
import iconButtonStyles from "@atoms/IconButton/IconButton.module.scss"

import styles from "./DatePicker.module.scss"

export const SHARED_CLASS_NAMES = {
    months: styles.months,
    month: styles.month,
    caption: styles.caption,
    caption_label: styles.captionLabel,
    nav: styles.nav,
    nav_button: clsx(iconButtonStyles.base, iconButtonStyles.ghostVariant, iconButtonStyles.lgSize),
    nav_button_previous: styles.navButtonPrevious,
    nav_button_next: styles.navButtonNext,
    table: styles.table,
    tbody: styles.tbody,
    head_row: styles.headRow,
    head_cell: styles.headCell,
    row: styles.row,
    cell: styles.cell,
    day: clsx(iconButtonStyles.base, styles.day),
    day_range_start: "day-range-start",
    day_range_end: "day-range-end",
    day_selected: styles.daySelected,
    day_today: styles.dayToday,
    day_outside: clsx("day-outside", styles.dayOutside),
    day_disabled: styles.dayDisabled,
    day_range_middle: styles.dayRangeMiddle,
    day_hidden: "invisible",
}

export const SHARED_COMPONENTS = {
    IconLeft: () => <Icon icon={faIcon({ name: "angle-left", style: "regular" })} className={styles.chevron} />,
    IconRight: () => <Icon icon={faIcon({ name: "angle-right", style: "regular" })} className={styles.chevron} />,
}

export const SHARED_DAY_PICKER_PROPS = {
    weekStartsOn: 1 as const,
    fixedWeeks: true,
}
